export default __webpack_public_path__ + "static/media/background.a66dac28.png";